import { createBrowserRouter, Navigate, Outlet } from 'react-router-dom';
import { AppShell } from './AppShell';
import { useAuth } from './lib/auth';
import { Auth } from './screens/Auth';
import { Onboarding } from './screens/Onboarding';
import { Settings } from './screens/Settings';
import { Home } from './screens/Home';
import { Diagnostic } from './screens/Diagnostic';
import { DrillScreen } from './screens/DrillScreen';
import { GuidedProblem } from './screens/GuidedProblem';
import { Workout } from './screens/Workout';
import { Review } from './screens/Review';
import { Mastery } from './screens/Mastery';
import { Repair } from './screens/Repair';
import { Library } from './screens/Library';
import { Contest } from './screens/Contest';
import { Postmortem } from './screens/Postmortem';
import { Assignments } from './screens/Assignments';
import { CoachLayout } from './screens/coach/CoachLayout';
import { CoachClasses } from './screens/coach/Classes';
import { ClassDetail } from './screens/coach/ClassDetail';
import { StudentProfile } from './screens/coach/StudentProfile';
import { AdminLayout } from './screens/admin/AdminLayout';
import { Inventory } from './screens/admin/Inventory';
import { ScenarioDetail } from './screens/admin/ScenarioDetail';
import { QAQueue } from './screens/admin/QAQueue';
import { NotFound } from './screens/NotFound';
import { MarketingLayout } from './screens/marketing/MarketingLayout';
import { MarketingHome } from './screens/marketing/Home';
import { HowItWorks, About, Privacy } from './screens/marketing/Pages';

/** Gate for signed-in areas. Sends guests to /auth, preserving where they were going. */
function RequireAuth() {
  const { status } = useAuth();
  if (status === 'loading') return <div className="route-loading">Loading…</div>;
  if (status === 'guest') return <Navigate to="/auth" replace />;
  return <Outlet />;
}

export const router = createBrowserRouter([
  {
    element: <MarketingLayout />,
    children: [
      { path: '/', element: <MarketingHome /> },
      { path: '/how-it-works', element: <HowItWorks /> },
      { path: '/about', element: <About /> },
      { path: '/privacy', element: <Privacy /> },
    ],
  },
  { path: '/auth', element: <Auth /> },
  {
    element: <RequireAuth />,
    children: [
      { path: '/onboarding', element: <Onboarding /> },
      {
        path: '/app',
        element: <AppShell />,
        children: [
          { index: true, element: <Home /> },
          { path: 'workout', element: <Workout /> },
          { path: 'review', element: <Review /> },
          { path: 'problem', element: <GuidedProblem /> },
          { path: 'diagnostic', element: <Diagnostic /> },
          { path: 'mastery', element: <Mastery /> },
          { path: 'repair', element: <Repair /> },
          { path: 'library', element: <Library /> },
          { path: 'contest', element: <Contest /> },
          { path: 'postmortem', element: <Postmortem /> },
          { path: 'drill/:kind', element: <DrillScreen /> },
          { path: 'settings', element: <Settings /> },
          { path: 'assignments', element: <Assignments /> },
        ],
      },
      {
        path: '/coach',
        element: <CoachLayout />,
        children: [
          { index: true, element: <CoachClasses /> },
          { path: 'class/:id', element: <ClassDetail /> },
          { path: 'student/:id', element: <StudentProfile /> },
        ],
      },
      {
        path: '/admin',
        element: <AdminLayout />,
        children: [
          { index: true, element: <Inventory /> },
          { path: 'content/:id/:version', element: <ScenarioDetail /> },
          { path: 'qa', element: <QAQueue /> },
        ],
      },
    ],
  },
  { path: '*', element: <NotFound /> },
]);
